export const INCIDENT_SHEET_ID = "incident";

function urlFilesOnly(files: unknown): string[] {
  return Array.isArray(files) ? files.filter((file): file is string => typeof file === "string") : [];
}

function slimProperty(property: unknown) {
  if (!property || typeof property !== "object" || !("id" in property)) {
    return property;
  }
  const p = property as {id: number; name?: string};
  return {id: p.id, name: typeof p.name === "string" ? p.name : ""};
}

function slimType(type: unknown) {
  if (!type || typeof type !== "object" || !("incident_report_type_id" in type)) {
    return type;
  }
  const t = type as {incident_report_type_id: number; type?: string};
  return {
    incident_report_type_id: t.incident_report_type_id,
    type: typeof t.type === "string" ? t.type : "",
  };
}

export function getIncidentFormDraftKey(
  isEditing: boolean,
  incidentId?: number | null,
  contextPropertyId?: number | null,
) {
  if (isEditing && incidentId != null) {
    return `incident:edit:${incidentId}`;
  }
  if (contextPropertyId != null) {
    return `incident:create:${contextPropertyId}`;
  }
  return "incident:create";
}

export function serializeIncidentFormDraftValues(values: Record<string, unknown>) {
  const incidentDate = values.incident_date;
  return {
    type: slimType(values.type),
    details: values.details ?? "",
    incident_date:
      incidentDate instanceof Date
        ? incidentDate.toISOString()
        : typeof incidentDate === "string"
          ? incidentDate
          : null,
    incident_time: values.incident_time ?? null,
    incident_location: values.incident_location ?? "",
    property: slimProperty(values.property),
    files: urlFilesOnly(values.files),
    send_notification: values.send_notification ?? 0,
    include_gps_coordinates: values.include_gps_coordinates ?? 0,
  };
}

export function deserializeIncidentFormDraftValues(values: Record<string, unknown>) {
  const incidentDate = values.incident_date;
  return {
    ...values,
    incident_date:
      typeof incidentDate === "string"
        ? new Date(incidentDate)
        : incidentDate instanceof Date
          ? incidentDate
          : new Date(),
    files: Array.isArray(values.files) ? values.files : [],
  };
}

export function incidentFormHasPersistableContent(values: Record<string, unknown>) {
  const details = typeof values.details === "string" ? values.details.trim() : "";
  const location =
    typeof values.incident_location === "string" ? values.incident_location.trim() : "";
  const files = Array.isArray(values.files) ? values.files : [];
  return (
    details.length > 0 ||
    location.length > 0 ||
    files.length > 0 ||
    values.type != null ||
    values.send_notification === 1 ||
    values.include_gps_coordinates === 1
  );
}
